enum Gender {
  Male = "MALE",
  Female = "FEMALE",
  NonBinary = "NON_BINARY",
}

export default Gender;
